import { t } from '@lingui/core/macro';

const url_backend = process.env.REACT_APP_URL_BACKEND;

/**
 * A function to validate login data
 * @param {object} signinObject - Sign in data
 * @returns {boolean}  Return true if the sign in data is valid
 */
export const isValidSigninData = (signinObject) => {
  if (!signinObject) {
    console.log("!!!!!--- signin object undefined!");
    return false;
  }
  if (!signinObject.hasOwnProperty("email")) {
    console.log("!!!!!--- signin object property email or email  undefined!");
    return false;
  }

  if (!signinObject.hasOwnProperty("password")) {
    console.log(
      "!!!!!--- signin object property password or email  undefined!"
    );
    return false;
  }

  if (signinObject.email.trim().length < 4) {
    console.log("!!!!!--- email  not valid!");
    return false;
  }

  if (signinObject.password.trim().length < 4) {
    console.log("!!!!!--- password length  not valid!");
    return false;
  }

  return true;
};

/**
 * A function to validate signup data
 * @param {object} signupObject - Sign up data
 * @returns {boolean}  Return true if the sign up data is valid
 */
export const isValidSignupData = (signupObject) => {
  if (!isValidSigninData(signupObject)) {
    console.log("!!!!!--- signin object not valid!");
    return false;
  }
  if (!signupObject.hasOwnProperty("username")) {
    console.log("!!!!!--- signup object property username or username  undefined!");
    return false;
  }

  if (signupObject.username.trim().length < 4) {
    console.log("!!!!!--- username  not valid!");
    return false;
  }

  if (!signupObject.hasOwnProperty("repassword")) {
    console.log(
      "!!!!!--- signin object property password or email  undefined!"
    );
    return false;
  }

  if (signupObject.password.trim() !== signupObject.repassword.trim()) {
    console.log("!!!!!--- password not match!");
    return false;
  }

  return true;
};

/**
 * A function to validate user update data
 * @param {object} updateObject - User update data in data
 * @returns {boolean}  Return true if the sign in data is valid
 */
export const isValidUpdateData = (updateObject) => {
  if (!updateObject.hasOwnProperty("username")) {
    console.log("!!!!!--- update object property username or username  undefined!");
    return false;
  }

  if (updateObject.username.trim().length < 4) {
    console.log("!!!!!--- username  not valid!");
    return false;
  }

  if (!updateObject.hasOwnProperty("password")) {
    console.log("!!!!!--- signup object property password or password  undefined!");
    return false;
  }

  if (updateObject.password.trim().length < 4) {
    console.log("!!!!!--- password length  not valid!");
    return false;
  }

  if (!updateObject.hasOwnProperty("repassword")) {
    console.log(
      "!!!!!--- signin object property password or email  undefined!"
    );
    return false;
  }

  if (updateObject.password.trim() !== updateObject.repassword.trim()) {
    console.log("!!!!!--- password not match!");
    return false;
  }

  return true;
};
/**
 * A function to validate reset data
 * @param {object} resetObject - Reset data
 * @returns {boolean}  Return true if the reset data is valid
 */
export const isValidResetData = (resetObject) => {
  if (!resetObject) {
    console.log("!!!!!--- reset object undefined!");
    return false;
  }
  if (!resetObject.hasOwnProperty("email")) {
    console.log("!!!!!--- resetO object property email or email  undefined!");
    return false;
  }

  if (resetObject.email.trim().length < 4) {
    console.log("!!!!!--- email  not valid!");
    return false;
  }
  return true;
}

/**
 * A function to validate login data
 * @param {object} signinObject - Sign in data
 * @returns {boolean}  Return true if the sign in data is valid
 */
export const signUpApiCall = async (formData) => {

  try {
    if (!isValidSignupData(formData)) {
      throw new Error(t`Signup data not valid`);
    }

    //  return { success: true }
    const response = await fetch(url_backend + "api/auth/register", {
      method: "POST",
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      body: JSON.stringify(formData),
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Signup failed");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Signup API error:", error);
    return { success: false, error };
  }
};

/**
 * A function to call a signin api
 * @param {object} formData - Sign in data
 * @returns {object}  Return a message object
 */
export const signInApiCall = async (formData) => {
  try {
    if (!isValidSigninData(formData)) {
      throw new Error("Login data not valid");
    }

    // return { success: true }
    const response = await fetch(url_backend + "api/auth/login", {
      method: "POST",
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      body: JSON.stringify(formData),
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Login failed");
    }
    //console.log(response.headers.getSetCookie());

    return { success: true, data };
  } catch (error) {
    console.error("Login API error:", error);
    return { success: false, error };
  }
};


/**
 * A function to call a reset request password api
 * @param {object} formData - Password reset data
 * @returns {object}  Return a message object
 */
export const requestResetPwdApiCall = async (formData) => {
  try {
    if (!isValidResetData(formData)) {
      throw new Error("Login data not valid");
    }

    // return { success: true }
    const response = await fetch(url_backend + "api/auth/requestresetpwd", {
      method: "POST",
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      body: JSON.stringify(formData),
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Reset failed");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Reset API error:", error);
    return { success: false, error };
  }
};

/**
 * A function to call a reset password api
 * @param {object} formData - Sign in data
 * @param {string} id - User id
 * @param {string} token - User token
 * @returns {object}  Return a message object
 */
export const resetPwdApiCall = async (formData, id, token) => {
  try {

    // return { success: true }
    const response = await fetch(url_backend + "api/auth/resetpwd/" + id + "/" + token, {
      method: "POST",
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      body: JSON.stringify(formData),
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Reset failed");
    }
    //console.log(response.headers.getSetCookie());

    return { success: true, data };
  } catch (error) {
    console.error("Reset API error:", error);
    return { success: false, error };
  }
};

/**
 * A function to call a logout api
 * @returns {object}  Return a message object
 */
export const logOutCall = async () => {
  try {
    const response = await fetch(url_backend + "api/auth/logout", {
      method: "POST",
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Logout failed");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Logout API error:", error);
    return { success: false, error };
  }
};

/**
 * A function to call an user data update api
 * @param {object} formData - User data
 * @returns {object}  Return a message object
 */
export const updateApiCall = async (formData) => {
  try {
    if (!isValidUpdateData(formData)) {
      throw new Error("Update data not valid");
    }
    // return { success: true }
    const response = await fetch(url_backend + "api/auth/update", {
      method: "PUT",
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      body: JSON.stringify(formData),
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Update login failed");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Update login API error:", error);
    return { success: false, error };
  }
};

/**
 * A function to call a user login data api
 * @returns {object}  Return a message object
 */
export const retrieveUserLogin = async () => {
  // Check for cookie authenticated
  try {
    const response = await fetch(url_backend + "api/auth/user", {
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      method: "GET",
      credentials: "include"
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Retrieve login failed");
    }


    if (data.errorResponse) {
      throw new Error(data.errorResponse);
    }
    return { success: true, data };
  } catch (error) {
    console.error(
      "Si è verificato un errore durante l'ottenimento dell'utente:",
      error
    );
    return { success: false, error };
  }
};

/**
 * A function to call a delete user api
 * @returns {object}  Return a message object
 */
export const eraseApiCall = async () => {
  // Check for cookie authenticated
  try {
    const response = await fetch(url_backend + "api/auth/erase", {
      headers: { 'Access-Control-Allow-Credentials': 'true', 'Accept': 'application/json', "Content-Type": "application/json" },
      credentials: 'include',
      method: "DELETE",
      // …
    });


    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Erase login failed");
    }

    if (data.errorResponse) {
      throw new Error(data.errorResponse);
    }
    return { success: true, data };
  } catch (error) {
    console.error(
      "Si è verificato un errore durante la cancellazione dell'utente:",
      error
    );
    return { success: false, error };
  }
};


/**
 * A function to call a logout api
 * @returns {object}  Return a message object
 */
export const logoutApiCall = async () => {
  // Check for cookie authenticated
  try {
    const response = await fetch(url_backend + "api/auth/logout", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
      credentials: "include"
      // …
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Logout attempt failed");
    }

    if (data.errorResponse) {
      throw new Error(data.errorResponse);
    }
    return { success: true, data };
  } catch (error) {
    console.error(
      "Si è verificato un errore durante il logout:",
      error
    );
    return { success: false, error };
  }
};
